export default "__VITE_ASSET__B8jMiaSe__"